import { Accordion, AccordionDetails, AccordionSummary, Avatar, Box, Button, Drawer, IconButton, Stack, Typography } from "@mui/material";
import React from "react";
import img from "../../../images/testimonial.png";
import GridViewIcon from '@mui/icons-material/GridView';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LogoutIcon from '@mui/icons-material/Logout';
import WalletIcon from '../../../images/wallet.svg';
import CandidateIcon from '../../../images/candidate.svg';
import PackagesIcon from '../../../images/package.svg';
import MessageIcon from '../../../images/message.svg';
import SettingIcon from '../../../images/setting.svg';
import Avaibility from '../../../images/avalablity.svg';
import Coach from '../../../images/service.svg';
import Alert from '../../../images/service.svg';
import Favourite from '../../../images/service.svg';
import Service from '../../../images/service.svg';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { ArrowBackIos } from "@mui/icons-material";

export default function CandidateSideBar() {
    const SideBarItems = [
        {
            name: 'Jobs', icon: WalletIcon,
            subItems: [
                { name: 'Recommonded Job', url: '/candidate/recommanded-jobs' },
                { name: 'Applied Job', url: '/candidate/applied-jobs' },
                { name: 'Browse Job', url: '/candidate/browse-jobs' }
            ]
        },
        {
            name: 'Coach', icon: Coach, subItems: [
                { name: 'Recommended Coach', url: '/candidate/recommended-coach' },
                { name: 'Service', url: '/candidate/candidate-service' },
                { name: 'Upcoming Service', url: '/candidate/upcoming-Service' },
                { name: 'Manage Service', url: '/candidate/manage-Service' },
                { name: 'Order History', url: '/candidate/order-history' },
                { name: 'Browse Coach', url: '/candidate/browse-coach' },
            ]
        },
        { name: 'Company', icon: CandidateIcon, subItems: [] },
        { name: 'Favourite', icon: Favourite, subItems: [] },
        { name: 'Avaibility', icon: Avaibility, subItems: [] },
        { name: 'Message', icon: MessageIcon, subItems: [] },
        { name: 'Create Alert', icon: Alert, subItems: [] },
        { name: 'Settings ', icon: SettingIcon, subItems: [] },
    ];

    const navigate = useNavigate();
    const { user } = useSelector((state) => ({ ...state }));
    const dispatch = useDispatch();

    const handleLogout = () => {
        localStorage.removeItem("user");
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("rememberMe");
        dispatch({
            type: "LOG_OUT",
        });
        navigate('/');
    }

    const [state, setState] = React.useState({
        left: false,
    });

    const toggleDrawer = (anchor, open) => (event) => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }

        setState({ ...state, [anchor]: open });
    };

    const [anchorElNav, setAnchorElNav] = React.useState(null);

    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };

    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };

    return (
        <>
            <Box
                pb={3}
                sx={{
                    background: "#2544EE",
                    backdropFilter: "blur(91.5625px)",
                    borderRadius: "30px",
                    height: "100%",
                }}
                className="mHide"
            >
                <Box p={4}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <Avatar alt="profile" src={user.avatar} sx={{ width: 56, height: 56 }} />
                        <Box>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    opacity: ".4",
                                    fontSize: 12,
                                    lineHeight: "24px",
                                    fontFamily: "Inter",
                                    fontWeight: 500,
                                }}
                            >
                                It Service
                            </Typography>
                            <Typography
                                sx={{
                                    color: "#fff",
                                    fontSize: 16,
                                    lineHeight: "24px",
                                    fontFamily: "Inter",
                                    fontWeight: 500,
                                }}
                            >
                                {user.name}
                            </Typography>
                        </Box>
                    </Stack>
                    {/* <Typography
                    sx={{
                        color: "#fff",
                        fontSize: 8,
                        lineHeight: "24px",
                        fontFamily: "Inter",
                        fontWeight: 500,
                    }}
                >
                60% completed your profile
                </Typography> */}
                </Box>

                <Stack mx={2} direction="row" spacing={2} alignItems="center" justifyContent="center" verticalAlign="middle"
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: '0.5rem',
                        color: '#000',
                    }}
                >
                    <GridViewIcon />
                    <Button sx={{ color: '#000' }}>Dashboard</Button>
                    <ChevronRightIcon />
                </Stack>

                <Stack px={3} mt={2}>
                    <Typography
                        sx={{
                            color: "#fff",
                            fontSize: 12,
                            lineHeight: "24px",
                            fontFamily: "Inter",
                            fontWeight: 500,
                        }}
                    >
                        Main
                    </Typography>
                </Stack>

                <Box>
                    {SideBarItems.map((item, index) => (
                        <Accordion key={index} sx={{ width: '100%', backgroundColor: 'transparent', boxShadow: 'none', color: '#fff' }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                                sx={{ alignItems: 'center' }}
                            >
                                <img src={item.icon} alt="icons" style={{ marginRight: '8px' }} />
                                <Typography>{item.name}</Typography>
                            </AccordionSummary>
                            <AccordionDetails>
                                {item.subItems.map((subItem, index) => (
                                    <Link style={{ display: 'block', color: '#fff', textDecoration: 'none', marginLeft: '3rem', marginBottom: '0.5rem' }} to={subItem.url} key={index}>{subItem.name}</Link>
                                ))}
                            </AccordionDetails>
                        </Accordion>
                    ))}
                </Box>

                <Stack mx={2} my={2} direction="row" spacing={2} alignItems="center" justifyContent="center" verticalAlign="middle"
                    sx={{
                        backgroundColor: '#fff',
                        borderRadius: '0.5rem',
                        color: '#000',
                    }}
                >
                    <LogoutIcon />
                    <Button sx={{ color: '#000' }} onClick={handleLogout}>Logout</Button>
                </Stack>
            </Box>
            {/* Mobile view */}
            <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
                <React.Fragment>
                    <Button onClick={toggleDrawer('left', true)}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="#000"
                        >
                            <ArrowBackIos />
                        </IconButton>
                    </Button>
                    <Drawer
                        anchor={'left'}
                        open={state['left']}
                        onClose={toggleDrawer('left', false)}
                        className="customDrawerColor"
                    >
                        <Box>
                            <Box p={6} >
                                <Stack direction="row" spacing={6} alignItems="center">
                                    <Avatar alt="profile" src={user.avatar} sx={{ width: 56, height: 56 }} />
                                    <Box>
                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                opacity: ".4",
                                                fontSize: 12,
                                                lineHeight: "24px",
                                                fontFamily: "Inter",
                                                fontWeight: 500,
                                            }}
                                        >
                                            It Service
                                        </Typography>
                                        <Typography
                                            sx={{
                                                color: "#fff",
                                                fontSize: 16,
                                                lineHeight: "24px",
                                                fontFamily: "Inter",
                                                fontWeight: 500,
                                            }}
                                        >
                                            {user.name}
                                        </Typography>
                                    </Box>
                                </Stack>
                            </Box>

                            <Stack mx={2} direction="row" spacing={2} alignItems="center" justifyContent="center" verticalAlign="middle"
                                sx={{
                                    backgroundColor: '#fff',
                                    borderRadius: '0.5rem',
                                    color: '#000',
                                }}
                            >
                                <GridViewIcon />
                                <Button sx={{ color: '#000' }}>Dashboard</Button>
                                <ChevronRightIcon />
                            </Stack>

                            <Stack px={3} mt={2}>
                                <Typography
                                    sx={{
                                        color: "#fff",
                                        fontSize: 12,
                                        lineHeight: "24px",
                                        fontFamily: "Inter",
                                        fontWeight: 500,
                                    }}
                                >
                                    Main
                                </Typography>
                            </Stack>

                            <Box>
                                {SideBarItems.map((item, index) => (
                                    <Accordion key={index} sx={{ width: '100%', backgroundColor: 'transparent', boxShadow: 'none', color: '#fff' }}>
                                        <AccordionSummary
                                            expandIcon={<ExpandMoreIcon sx={{ color: '#fff' }} />}
                                            sx={{ alignItems: 'center' }}
                                        >
                                            <img src={item.icon} alt="icons" style={{ marginRight: '8px' }} />
                                            <Typography>{item.name}</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                            {item.subItems.map((subItem, index) => (
                                                <Link style={{ display: 'block', color: '#fff', textDecoration: 'none', marginLeft: '3rem', marginBottom: '0.5rem' }} to={subItem.url} key={index}>{subItem.name}</Link>
                                            ))}
                                        </AccordionDetails>
                                    </Accordion>
                                ))}
                            </Box>

                            <Stack mx={2} my={2} direction="row" spacing={2} alignItems="center" justifyContent="center" verticalAlign="middle"
                                sx={{
                                    backgroundColor: '#fff',
                                    borderRadius: '0.5rem',
                                    color: '#000',
                                }}
                            >
                                <LogoutIcon />
                                <Button sx={{ color: '#000' }} onClick={handleLogout}>Logout</Button>
                            </Stack>
                        </Box>
                    </Drawer>
                </React.Fragment>
            </Box>
        </>
    );
}
